import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchTagsRequest } from "api/tags";

export const fetchTags = createAsyncThunk("@tags/fetch", async () => {
    return await fetchTagsRequest();
});